import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Controller } from "react-hook-form";

const RadioInput = ({ item, id, paramSelected, control }) => {
	return (
		<div className="radio col-6 col-sm-4 col-lg-4 mt-2 ">
			<Controller
				name={id}
				control={control}
				defaultValue=""
				render={({ field: { onChange, value } }) => (
					<>
						<input
							type="radio"
							id={item.value}
							value={item.value}
							onChange={(e) => {
								const selected = { value: item.value, label: item.label };
								onChange(selected); // Atualiza o valor com o objeto { value, label }
							}}
							checked={value?.value === item.value}
							style={{ display: "none" }}
						/>
						<label htmlFor={item.value}>
							<span
								style={{
									marginRight: "0.5rem",
								}}
							>
								<FontAwesomeIcon
									icon={value?.value === item.value ? faCheckSquare : faSquare}
									className="custom-checkbox"
								/>
							</span>
							{item.label}
						</label>
					</>
				)}
			/>
		</div>
	);
};

export default RadioInput;
